var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgEye = function SvgEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7142 12C22.7142 13.8002 17.9173 20.1429 11.9999 20.1429C6.08259 20.1429 1.28564 13.8002 1.28564 12C1.28564 10.1999 6.08259 3.85718 11.9999 3.85718C17.9173 3.85718 22.7142 10.1999 22.7142 12Z",
    stroke: "currentColor",
    strokeWidth: 1.71429,
    vectorEffect: "non-scaling-stroke",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 15.4286C13.8935 15.4286 15.4285 13.8936 15.4285 12C15.4285 10.1065 13.8935 8.57146 11.9999 8.57146C10.1064 8.57146 8.57136 10.1065 8.57136 12C8.57136 13.8936 10.1064 15.4286 11.9999 15.4286Z",
    stroke: "currentColor",
    strokeWidth: 1.71429,
    vectorEffect: "non-scaling-stroke",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export { SvgEye as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik0yMi43MTQyIDEyQzIyLjcxNDIgMTMuODAwMiAxNy45MTczIDIwLjE0MjkgMTEuOTk5OSAyMC4xNDI5QzYuMDgyNTkgMjAuMTQyOSAxLjI4NTY0IDEzLjgwMDIgMS4yODU2NCAxMkMxLjI4NTY0IDEwLjE5OTkgNi4wODI1OSAzLjg1NzE4IDExLjk5OTkgMy44NTcxOEMxNy45MTczIDMuODU3MTggMjIuNzE0MiAxMC4xOTk5IDIyLjcxNDIgMTJaIgogICAgICAgICAgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMS43MTQyOSIgdmVjdG9yLWVmZmVjdD0ibm9uLXNjYWxpbmctc3Ryb2tlIiBzdHJva2UtbGluZWNhcD0icm91bmQiCiAgICAgICAgICBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CiAgICA8cGF0aCBkPSJNMTEuOTk5OSAxNS40Mjg2QzEzLjg5MzUgMTUuNDI4NiAxNS40Mjg1IDEzLjg5MzYgMTUuNDI4NSAxMkMxNS40Mjg1IDEwLjEwNjUgMTMuODkzNSA4LjU3MTQ2IDExLjk5OTkgOC41NzE0NkMxMC4xMDY0IDguNTcxNDYgOC41NzEzNiAxMC4xMDY1IDguNTcxMzYgMTJDOC41NzEzNiAxMy44OTM2IDEwLjEwNjQgMTUuNDI4NiAxMS45OTk5IDE1LjQyODZaIgogICAgICAgICAgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMS43MTQyOSIgdmVjdG9yLWVmZmVjdD0ibm9uLXNjYWxpbmctc3Ryb2tlIiBzdHJva2UtbGluZWNhcD0icm91bmQiCiAgICAgICAgICBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";